/* ============================================================
   Lagomlo — placeholder.js (Shopify theme)
   Deterministic inline SVG placeholder generator per product
   handle (DESIGN.md §3.3): warm gradients + simple blanket /
   pillow / mug shapes + soft grain. No external images.
   Fills <div data-placeholder="handle"> elements (rendered by
   snippets/placeholder-image.liquid) with inline SVG; keeps the
   <noscript> data-URI <img> as the no-JS fallback.
   Exposed as window.LagomloPlaceholder.
   ============================================================ */
(function (global) {
  'use strict';

  // Deterministic string hash -> 32-bit seed
  function hashSeed(str) {
    var h = 2166136261 >>> 0;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619) >>> 0;
    }
    return h >>> 0;
  }

  // mulberry32 PRNG (deterministic)
  function rng(seed) {
    var a = seed >>> 0;
    return function () {
      a |= 0; a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  var WARM = ['#F2E9DD', '#E9C9BC', '#C4704F'];
  var TINTS = ['#E9C9BC', '#DFB7A4', '#D9A441', '#C4704F', '#A85B3E', '#8C9A7E'];

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function grain(rand, w, h) {
    var dots = '';
    var n = Math.round((w * h) / 9000);
    for (var i = 0; i < n; i++) {
      var x = Math.round(rand() * w);
      var y = Math.round(rand() * h);
      var r = 0.6 + rand() * 1.4;
      var o = (0.04 + rand() * 0.08).toFixed(2);
      dots += '<circle cx="' + x + '" cy="' + y + '" r="' + r.toFixed(1) + '" fill="#3E2F26" opacity="' + o + '"/>';
    }
    return dots;
  }

  function paws(rand, x, y, s, color) {
    var main = 9 * s, toe = 4 * s;
    return '<ellipse cx="' + x + '" cy="' + y + '" rx="' + (main * 1.25) + '" ry="' + (main * 1.1) + '" fill="' + color + '" opacity=".55"/>'
      + '<circle cx="' + (x - main * 1.15) + '" cy="' + (y - main * 1.05) + '" r="' + toe + '" fill="' + color + '" opacity=".55"/>'
      + '<circle cx="' + (x + main * 1.15) + '" cy="' + (y - main * 1.05) + '" r="' + toe + '" fill="' + color + '" opacity=".55"/>'
      + '<circle cx="' + (x - main * 0.55) + '" cy="' + (y - main * 1.45) + '" r="' + (toe * 0.95) + '" fill="' + color + '" opacity=".55"/>'
      + '<circle cx="' + (x + main * 0.55) + '" cy="' + (y - main * 1.45) + '" r="' + (toe * 0.95) + '" fill="' + color + '" opacity=".55"/>';
  }

  function hearts(rand, x, y, s, color) {
    var out = '';
    for (var i = 0; i < 3; i++) {
      var hx = x + (i - 1) * s * 2.6;
      var hy = y + (rand() - 0.5) * s;
      out += '<path transform="translate(' + hx + ' ' + hy + ') scale(' + s + ')" d="M0 -2 C -2 -4 -6 -3.4 -6 -0.6 C -6 1.8 -2.4 4.4 0 6.6 C 2.4 4.4 6 1.8 6 -0.6 C 6 -3.4 2 -4 0 -2 Z" fill="' + color + '" opacity=".6"/>';
    }
    return out;
  }

  var idCounter = 1000;
  function nextId() { return 1000 + (++idCounter); }

  function blanketShape(w, h, rand, opts) {
    var m = w * 0.1, t = h * 0.1;
    var bw = w - m * 2, bh = h - t * 2;
    var gradId = 'bg' + nextId();
    var c1 = WARM[Math.floor(rand() * 2)];
    var c2 = WARM[1 + Math.floor(rand() * 2)];
    var fold = opts.fold !== false;
    var parts = '';
    parts += '<rect x="' + (m + 5) + '" y="' + (t + 7) + '" width="' + bw + '" height="' + bh + '" rx="24" fill="#3E2F26" opacity=".14"/>';
    parts += '<rect x="' + m + '" y="' + t + '" width="' + bw + '" height="' + bh + '" rx="24" fill="url(#' + gradId + ')"/>';
    parts += '<rect x="' + (m + 6) + '" y="' + (t + 6) + '" width="' + (bw - 12) + '" height="' + (bh - 12) + '" rx="18" fill="none" stroke="' + c2 + '" stroke-width="2" opacity=".7"/>';
    if (fold) {
      parts += '<path d="M ' + m + ' ' + (t + bh * 0.33) + ' L ' + (m + bw) + ' ' + (t + bh * 0.30) + '" stroke="' + c2 + '" stroke-width="2.5" opacity=".5" fill="none"/>';
      parts += '<path d="M ' + m + ' ' + (t + bh * 0.68) + ' L ' + (m + bw) + ' ' + (t + bh * 0.65) + '" stroke="' + c2 + '" stroke-width="2.5" opacity=".5" fill="none"/>';
    }
    if (opts.fringe) {
      var fy = t + bh - 4;
      var fcount = Math.floor(bw / 26);
      for (var f = 0; f <= fcount; f++) {
        var fx = m + 10 + (f * (bw - 20)) / fcount;
        parts += '<rect x="' + fx + '" y="' + fy + '" width="7" height="' + (16 + rand() * 8) + '" rx="3" fill="' + c2 + '" opacity=".8"/>';
      }
    }
    if (opts.paws) {
      parts += paws(rand, w * 0.3, h * 0.42, 0.9, '#A85B3E');
      parts += paws(rand, w * 0.68, h * 0.62, 0.75, '#8C9A7E');
      parts += paws(rand, w * 0.5, h * 0.78, 0.6, '#D9A441');
    }
    if (opts.hearts) {
      parts += hearts(rand, w * 0.5, h * 0.5, 6, '#C4704F');
    }
    if (opts.text) {
      parts += '<text x="' + (w / 2) + '" y="' + (h * 0.52) + '" text-anchor="middle" font-family="Georgia, serif" font-style="italic" font-size="' + (w * 0.05) + '" fill="#3E2F26" opacity=".65">' + esc(opts.text) + '</text>';
    }
    return parts;
  }

  function pillowShape(w, h, rand) {
    var m = w * 0.14;
    var side = Math.min(w, h) - m * 2;
    var x = (w - side) / 2, y = (h - side) / 2;
    var gradId = 'bg' + nextId();
    var c1 = WARM[Math.floor(rand() * 2)];
    var c2 = WARM[1 + Math.floor(rand() * 2)];
    var parts = '';
    parts += '<rect x="' + (x + 5) + '" y="' + (y + 7) + '" width="' + side + '" height="' + side + '" rx="' + side * 0.16 + '" fill="#3E2F26" opacity=".14"/>';
    parts += '<rect x="' + x + '" y="' + y + '" width="' + side + '" height="' + side + '" rx="' + side * 0.16 + '" fill="url(#' + gradId + ')"/>';
    parts += '<rect x="' + (x + 8) + '" y="' + (y + 8) + '" width="' + (side - 16) + '" height="' + (side - 16) + '" rx="' + side * 0.13 + '" fill="none" stroke="' + c2 + '" stroke-width="2" stroke-dasharray="7 6" opacity=".8"/>';
    var t = side * 0.08;
    parts += '<circle cx="' + (x + t) + '" cy="' + (y + t) + '" r="4" fill="' + c2 + '"/>';
    parts += '<circle cx="' + (x + side - t) + '" cy="' + (y + t) + '" r="4" fill="' + c2 + '"/>';
    parts += '<circle cx="' + (x + t) + '" cy="' + (y + side - t) + '" r="4" fill="' + c2 + '"/>';
    parts += '<circle cx="' + (x + side - t) + '" cy="' + (y + side - t) + '" r="4" fill="' + c2 + '"/>';
    parts += '<path d="M ' + (x + side * 0.3) + ' ' + (y + side * 0.5) + ' Q ' + (w / 2) + ' ' + (y + side * 0.38) + ' ' + (x + side * 0.7) + ' ' + (y + side * 0.5) + '" stroke="' + c2 + '" stroke-width="2" fill="none" opacity=".7"/>';
    parts += '<path d="M ' + (x + side * 0.3) + ' ' + (y + side * 0.62) + ' Q ' + (w / 2) + ' ' + (y + side * 0.52) + ' ' + (x + side * 0.7) + ' ' + (y + side * 0.62) + '" stroke="' + c2 + '" stroke-width="2" fill="none" opacity=".5"/>';
    return parts;
  }

  function mugShape(w, h, rand) {
    var mw = w * 0.5, mh = h * 0.56;
    var mx = (w - mw) / 2, my = h * 0.18;
    var gradId = 'bg' + nextId();
    var c1 = WARM[Math.floor(rand() * 2)];
    var c2 = WARM[1 + Math.floor(rand() * 2)];
    var parts = '';
    parts += '<path d="M ' + (mx + mw) + ' ' + (my + mh * 0.3) + ' C ' + (mx + mw + mw * 0.42) + ' ' + (my + mh * 0.3) + ' ' + (mx + mw + mw * 0.42) + ' ' + (my + mh * 0.78) + ' ' + (mx + mw) + ' ' + (my + mh * 0.78) + '" fill="none" stroke="' + c1 + '" stroke-width="' + mw * 0.11 + '" stroke-linecap="round"/>';
    parts += '<rect x="' + (mx + 5) + '" y="' + (my + 8) + '" width="' + mw + '" height="' + mh + '" rx="' + mw * 0.12 + '" fill="#3E2F26" opacity=".14"/>';
    parts += '<path d="M ' + mx + ' ' + (my + mw * 0.16) + ' L ' + mx + ' ' + (my + mh) + ' Q ' + mx + ' ' + (my + mh + mw * 0.12) + ' ' + (mx + mw * 0.12) + ' ' + (my + mh + mw * 0.12) + ' L ' + (mx + mw - mw * 0.12) + ' ' + (my + mh + mw * 0.12) + ' Q ' + (mx + mw) + ' ' + (my + mh + mw * 0.12) + ' ' + (mx + mw) + ' ' + (my + mh) + ' L ' + (mx + mw) + ' ' + (my + mw * 0.16) + ' Z" fill="url(#' + gradId + ')"/>';
    parts += '<ellipse cx="' + (mx + mw / 2) + '" cy="' + (my + mw * 0.16) + '" rx="' + mw / 2 + '" ry="' + mw * 0.09 + '" fill="' + c2 + '"/>';
    parts += '<ellipse cx="' + (mx + mw / 2) + '" cy="' + (my + mw * 0.17) + '" rx="' + mw * 0.4 + '" ry="' + mw * 0.065 + '" fill="' + c1 + '" opacity=".85"/>';
    var fx = mx + mw * 0.18, fy = my + mh * 0.24, fw = mw * 0.64, fh = mh * 0.5;
    parts += '<rect x="' + fx + '" y="' + fy + '" width="' + fw + '" height="' + fh + '" rx="8" fill="#FFF7EE"/>';
    parts += '<path d="M ' + fx + ' ' + (fy + fh * 0.72) + ' L ' + (fx + fw * 0.45) + ' ' + (fy + fh * 0.3) + ' L ' + (fx + fw) + ' ' + (fy + fh * 0.78) + ' Z" fill="' + c2 + '" opacity=".9"/>';
    parts += '<circle cx="' + (fx + fw * 0.72) + '" cy="' + (fy + fh * 0.36) + '" r="' + fw * 0.09 + '" fill="' + c1 + '"/>';
    parts += '<path d="M ' + (mx + mw * 0.3) + ' ' + (my - 12) + ' C ' + (mx + mw * 0.22) + ' ' + (my - 26) + ' ' + (mx + mw * 0.38) + ' ' + (my - 30) + ' ' + (mx + mw * 0.3) + ' ' + (my - 44) + '" stroke="' + c2 + '" stroke-width="3" fill="none" stroke-linecap="round" opacity=".7"/>';
    parts += '<path d="M ' + (mx + mw * 0.62) + ' ' + (my - 10) + ' C ' + (mx + mw * 0.55) + ' ' + (my - 24) + ' ' + (mx + mw * 0.7) + ' ' + (my - 28) + ' ' + (mx + mw * 0.63) + ' ' + (my - 40) + '" stroke="' + c2 + '" stroke-width="3" fill="none" stroke-linecap="round" opacity=".6"/>';
    return parts;
  }

  function shapeFor(handle, w, h, rand) {
    var opts = { fold: true };
    if (handle === 'photo-pillow') return pillowShape(w, h, rand);
    if (handle === 'custom-mug' || /mug/.test(handle)) return mugShape(w, h, rand);
    if (handle === 'pet-blanket') { opts.paws = true; return blanketShape(w, h, rand, opts); }
    if (handle === 'wedding-blanket') { opts.hearts = true; return blanketShape(w, h, rand, opts); }
    if (handle === 'text-blanket') { opts.text = 'Your Name · Est. 2024'; return blanketShape(w, h, rand, opts); }
    if (handle === 'photo-throw') { opts.fringe = true; return blanketShape(w, h, rand, opts); }
    if (handle === 'blanket-pillow-bundle') {
      var parts = blanketShape(w, h * 0.72, rand, { fold: true });
      var px = w * 0.62, py = h * 0.62, ps = Math.min(w, h) * 0.34;
      parts += '<rect x="' + (px + 4) + '" y="' + (py + 5) + '" width="' + ps + '" height="' + ps + '" rx="' + ps * 0.16 + '" fill="#3E2F26" opacity=".12"/>';
      parts += '<rect x="' + px + '" y="' + py + '" width="' + ps + '" height="' + ps + '" rx="' + ps * 0.16 + '" fill="#F7EDE1" stroke="#E9C9BC" stroke-width="2"/>';
      parts += '<rect x="' + (px + 7) + '" y="' + (py + 7) + '" width="' + (ps - 14) + '" height="' + (ps - 14) + '" rx="' + ps * 0.13 + '" fill="none" stroke="#C4704F" stroke-width="2" stroke-dasharray="6 5" opacity=".8"/>';
      return parts;
    }
    return blanketShape(w, h, rand, opts); // photo-blanket + default
  }

  function svgFor(handle, w, h, variant) {
    w = w || 800; h = h || 600;
    var seed = hashSeed((handle || 'photo-blanket') + ':' + (variant || 0));
    var rand = rng(seed);
    var gid = 'g' + seed.toString(16);
    var c0 = WARM[Math.floor(rand() * 2)];
    var c1 = WARM[1 + Math.floor(rand() * 2)];
    var c2 = TINTS[Math.floor(rand() * TINTS.length)];
    var angle = 120 + Math.floor(rand() * 40);
    var shapes = shapeFor(handle, w, h, rand);
    return '<svg xmlns="http://www.w3.org/2000/svg" width="' + w + '" height="' + h + '" viewBox="0 0 ' + w + ' ' + h + '" role="img" aria-label="' + esc(handle) + ' placeholder">'
      + '<defs><linearGradient id="' + gid + '" x1="0" y1="0" x2="1" y2="1" gradientTransform="rotate(' + angle + ' 0.5 0.5)">'
      + '<stop offset="0" stop-color="' + c0 + '"/><stop offset="0.55" stop-color="' + c1 + '"/>'
      + '<stop offset="1" stop-color="' + c2 + '" stop-opacity="0.9"/></linearGradient></defs>'
      + '<rect width="' + w + '" height="' + h + '" fill="url(#' + gid + ')"/>'
      + shapes
      + grain(rand, w, h)
      + '</svg>';
  }

  function dataUri(handle, w, h, variant) {
    return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgFor(handle, w, h, variant));
  }

  // Fill every <div data-placeholder="handle"> (optional "handle|variant")
  function fill(scope) {
    scope = scope || document;
    var divs = scope.querySelectorAll('[data-placeholder]');
    for (var i = 0; i < divs.length; i++) {
      var el = divs[i];
      var raw = (el.getAttribute('data-placeholder') || '').split('|');
      var handle = raw[0] || 'photo-blanket';
      var variant = parseInt(raw[1], 10) || 0;
      var ratio = el.getAttribute('data-placeholder-ratio');
      var w, h;
      if (ratio === 'square') { w = 600; h = 600; }
      else { w = 800; h = 600; }
      el.innerHTML = svgFor(handle, w, h, variant);
      el.setAttribute('aria-label', (el.getAttribute('data-placeholder-title') || 'Lagomlo ' + handle.replace(/-/g, ' ')));
    }
  }

  global.LagomloPlaceholder = { svg: svgFor, dataUri: dataUri, fill: fill };
})(window);
